export const errorMessagePretty = new Map<string, string>();
errorMessagePretty.set(
  'failed constraint unique_vehicle_organization_nickname',
  'A vehicle already exists with that name'
);
errorMessagePretty.set(
  'failed constraint unique_payer_organization_display_name',
  'A payer already exists with that display name'
);
